// extracted by mini-css-extract-plugin
export var active = "_mz-2";
export var recordingDot = "_mz-1";
export var recordingIndicator = "_mz-0";